// 全局区域 reload 混入
// 监听 Vuex region.selected 变化，自动调用页面的 getList / fetchData / loadData 方法
// 如果页面带有 listQuery.page，会重置到第一页
//
// 任何具备列表查询能力的 view 组件无需手动写 watch；
// 静态/详情页若不需要 reload 也无副作用 —— 会跳过没有这些方法的组件

export default {
  watch: {
    '$store.state.region.selected': {
      deep: true,
      handler() {
        // 优先重置分页到第一页
        if (this.listQuery && typeof this.listQuery === 'object' && 'page' in this.listQuery) {
          this.listQuery.page = 1
        }
        // 按优先级触发刷新方法
        if (typeof this.getList === 'function') {
          this.getList()
        } else if (typeof this.fetchData === 'function') {
          this.fetchData()
        } else if (typeof this.loadData === 'function') {
          this.loadData()
        }
      }
    }
  }
}
